const animateLaureatesAnimatedExhibitElement = (entry) => {
	entry.target.classList.add("animate");
};

const chooseHandler = (entry) => {
	if (entry.target.classList.contains("ddiff-laureates-animation")) {
		if (entry.isIntersecting) {
			animateLaureatesAnimatedExhibitElement(entry);
			laureatesAnimatedExhibitObserver.unobserve(entry.target);
		}
	}
};

const laureatesAnimatedExhibitObserver = new IntersectionObserver(
	(entries) =>
		entries.forEach((entry) => {
			chooseHandler(entry);
		}),
	{
		root: null,
		rootMargin: "0px 0px -25% 0px",
		threshold: 0
	}
);

export const observeLaureatesAnimatedExhibit = (laureatesAnimatedExhibitElement) => {
	if (laureatesAnimatedExhibitElement) {
		laureatesAnimatedExhibitObserver.observe(laureatesAnimatedExhibitElement);
	}
};

export const disconnectLaureatesAnimatedExhibitObserver = () => {
	laureatesAnimatedExhibitObserver.disconnect();
};
